import ActionWindow from 'src/action-window/action-window';
import { generateCashOfficeActionButtons } from 'src/cash-office-display/business-logic/cash-office-action-buttons';
import { disabledWhenActive, ITab } from 'src/common/interfaces/dtos/ITabs';
import { generateCustomerServiceActionButtons } from 'src/customer-service/components/customer-service-action-buttons';
import RecallOrderDisplay from 'src/recall-order-display/components/recall-order-display';

export const tabMapping: ITab[] = [
  {
    tabId: 'action-window',
    component: ActionWindow,
  },
  {
    tabId: 'customer-service',
    buttonList: {
      actions: generateCustomerServiceActionButtons,
      title: 'CustomerService_Tab_Heading_Return',
      testId: 'customer-service-title-container',
    },
  },
  {
    tabId: 'cash-office',
    buttonList: {
      actions: generateCashOfficeActionButtons,
      title: 'CashOffice_Command',
      testId: 'cash-office-title-text',
    },
    disabledWhen: disabledWhenActive,
  },
  {
    tabId: 'peripherals',
  },
  {
    tabId: 'recall-order',
    component: RecallOrderDisplay,
    disabledWhen: disabledWhenActive,
  },
];
